import { render } from "./Shoprentexit.vue?vue&type=template&id=45ab4a4f&scoped=true"
import script from "./Shoprentexit.vue?vue&type=script&lang=js"
export * from "./Shoprentexit.vue?vue&type=script&lang=js"

import "./Shoprentexit.vue?vue&type=style&index=0&id=45ab4a4f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ab4a4f"]])

export default __exports__